(function () {
  const atcElement = document.querySelector(".product__cart-functions");
  const atcElementHeight = atcElement.getBoundingClientRect().height;
  const aboveElement = document.querySelector(".product-title--top");
  const descriptionElement = document.querySelector(".sticky-nav-container");
  const className = "sticky-addToCart";
  const breakpoint = 768;

  const addSticky = () => {
    atcElement.classList.add(className);
    aboveElement.style.marginBottom = `${atcElementHeight}px`;
  };
  const removeSticky = () => {
    atcElement.classList.remove(className);
    aboveElement.style.marginBottom = `0px`;
  };
  const atcPosition =
    atcElement.getBoundingClientRect().bottom + window.scrollY;

  const setupStickyAddToCart = () => {
    document.addEventListener("scroll", () => {
      const descriptionEnd =
        descriptionElement.getBoundingClientRect().bottom +
        window.scrollY -
        480;
      if (window.innerWidth < breakpoint) {
        if (window.scrollY > atcPosition && window.scrollY < descriptionEnd) {
          addSticky();
        } else {
          removeSticky();
        }
      } else {
        removeSticky();
      }
    });
    document.addEventListener("resize", () => {
      console.log("resize");
    });
  };
  document.addEventListener("DOMContentLoaded", () => {
    setupStickyAddToCart();
  });
})();
